<template>
  <div class="blk_timetable">
    <p v-if='detail.treatment_detail.strength' class="timetable_strength"><i class="icon-clock2"></i>{{ detail.treatment_detail.strength }}</p>
    <table class="timetable">
      <thead>
        <tr>
          <th>診療時間</th><td>日</td><td>月</td><td>火</td><td>水</td><td>木</td><td>金</td><td>土</td><td>祝</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="time in detail.treatment">
          <th>{{ time.time }}</th><td v-for="state in time.operation" v-html="operationState(state)"></td>
        </tr>
      </tbody>
    </table>
    <dl v-if='detail.treatment_detail' class="timetable_detail">
      <dt v-if="detail.treatment_detail.close">休診日</dt><dd class="detail_holiday">{{ detail.treatment_detail.close }}</dd>
      <template v-for="ex in detail.treatment_detail.exceptions">
      <dt>{{ ex.mark }}</dt><dd class="detail_mark">{{ ex.text }}</dd>
      </template>
    </dl>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Timetable',
  props: {
    msg: String
  },
  data () {
    return {
      detail: siteData.detail
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ])
  },
  methods: {
    operationState (mark) {
      if (mark == "●") {
        return '<i class="ico_circle"></i>'
      } else if (mark == "▲") {
        return '<i class="ico_triangle"></i>'
      }
      return '休'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
